import React from 'react'
import { useTranslation } from 'react-i18next'

interface ErrorProps {
  text?: string
}

const ErrorText = ({ text }: ErrorProps) => {
  const { t, i18n } = useTranslation()

  const style = React.useMemo(() => ({ color: '#db2828' }), [])

  if (!text) return null

  return <span style={style}>{i18n.exists(text) ? t(text) : text}</span>
}

const NonBreakingSpace = () => <>&nbsp;</>

interface Props {
  htmlFor?: string
  className?: string
  content?: React.ReactNode
  error?: string
  touched: boolean
}

const Label = (props: Props) => {
  const { content, error, htmlFor, touched, className } = props

  const hasContent = Boolean(content)
  const hasError = Boolean(error)

  if (!hasContent && !hasError) return null

  if (!hasContent && hasError && !touched) return null

  const hasContentAndError = hasContent && hasError && touched

  return (
    <label className={className} htmlFor={htmlFor}>
      {content}
      {hasContentAndError && <NonBreakingSpace />}
      {touched && <ErrorText text={error} />}
    </label>
  )
}

export default Label
